<template>
    <EpubPreview
        :bookId="bookId"
        role="teacher"
        :userUid="teacher?.uid || ''"
        :schoolUid="school?.uid"
        :source="source"
        @close="close"
    />
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import EpubPreview from '~/components/EpubPreview.vue';
import { useContentRegistryStore } from '~/stores/contentRegistry';

definePage({
    meta: {
        layout: 'epub-reader',
    },
});

const store = useTeacherStore();
store.fetchTeacher();
const { school, teacher } = storeToRefs(store);
const { getDownloadUrl } = useContentRegistryStore();
const router = useRouter();
const route = useRoute('/teacher/book/[book_id]/view-epub');
const bookId = parseInt(route.params.book_id + '') || 0;
const source = await getDownloadUrl(bookId);

const close = () => {
    router.push(`/teacher/book/${bookId}/about`);
};
</script>
<style scoped lang="scss"></style>
